module.exports = __webpack_public_path__ + "static/media/logoLogin.9a0a8c3d.png";